export const SLACK_LOGOUT = 'SLACK_LOGOUT'

export const on_slack_logout = () => ({
  type : SLACK_LOGOUT
})
